var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"paymentSetup"},[_c('PageHeader',{attrs:{"title":'付款設定'},on:{"toLastPage":_vm.toLastPage}}),_c('p',{staticClass:"paymentSetup__text paymentSetup__text--info"},[_vm._v("選擇您的支付方式")]),_c('PaymentSetupList',{staticClass:"paymentSetup__list",on:{"addCreditCard":_vm.toNewCreditCardPage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }